$(document).ready(function() {
    google.charts.load('current', {
        'packages': ['corechart']
    });
});